import {
	memo,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle'
import backArrow from 'root/src/client/public/icons/ic-back-arrow.svg'
import withModuleContext from 'root/src/client/util/withModuleContext'
import fillTemplate from 'root/src/shared/util/fillTemplate'
import modalModuleConnector from 'root/src/client/logic/modal/connectors/modalModuleConnector'
import styles from 'root/src/client/web/modal/rootStyles'
import {
	BRAND_PAYMENT_MODAL_MODULE_ID,
	CROP_IMAGE_MODAL_MODULE_ID,
	DELETE_COUPON_MODAL_MODULE_ID,
	FOLLOW_CREATOR_MODAL_MODULE_ID,
	DROP_ADD_MORE_MODAL_MODULE_ID,
	NO_CAMPAIGN_MODAL_MODULE_ID,
	REJECT_PROJECT_MODAL_MODULE_ID,
	NO_PUBLISHER_SETTINGS_MODAL_MODULE_ID,
	SUCCESS_MODAL_MODULE_ID,
	DROP_IS_OVER_MODAL_MODULE_ID,
	INITIAL_KEY_SELECTION_MODULE_ID,
	DELETE_ACCOUNT_MANAGER_MODAL_MODULE_ID,
	GAMING_PLATFORMS_SELECTION_MODAL_MODULE_ID,
	GET_STARTED_MODULE_ID,
	SIGN_UP_MODAL_MODULE_ID,
	SIGN_IN_MODAL_MODULE_ID,
	REVIEW_DELIVERY_OPTIONS_MODAL_MODULE_ID,
	ADMIN_CAMPAIGN_MANAGEMENT_MODAL_MODULE_ID,
	POINTS_MARKETPLACE_PURCHASE_MODAL_MODULE_ID,
	HOW_TO_EARN_POINTS_MODAL_MODULE_ID,
	POINTS_CASH_OUT_MODAL_MODULE_ID,
	INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID,
	TIKTOK_SET_EMAIL_MODAL_MODULE_ID,
	NOTIFICATIONS_MODAL_MODULE_ID,
	WHITELIST_FORM_MODAL_MODULE_ID,
	VIDEO_PLAYER_MODAL_MODULE,
	DARE_SUBMISSION_MODAL_MODULE_ID,
	EDIT_BRAND_KEYS_MODAL_MODULE_ID,
	EDIT_BRAND_CODES_MODAL_MODULE_ID,
	PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID,
	MULTIGAME_DROP_REPORT_MODAL_MODULE_ID,
	DROP_JOINED_MODAL_MODULE_ID,
	PUBLISHER_SETTINGS_MODAL_MODULE_ID,
	GET_VERIFIED_MODAL_MODULE_ID,
	SPONSORSHIP_DETAILS_MODULE_ID,
	PUBLISHER_BAN_LIST_FORM_MODAL_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import dynamic from 'next/dynamic'
import { DynamicImportPlaceholder } from 'root/src/client/web/base/DynamicImportPlaceholder'
import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds'
import { ModalContextLegacyProvider } from 'root/src/client/web/contexts/modal-context.legacy'
import { authModuleIds } from 'root/src/client/web/auth/descriptions/modules/authModuleIds'

const modalModuleIds = {
	[REJECT_PROJECT_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/RejectDareModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[POINTS_MARKETPLACE_PURCHASE_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/PointsMarketplacePurchaseModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[GAMING_PLATFORMS_SELECTION_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/GamingPlatformsSelectionModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[ADMIN_CAMPAIGN_MANAGEMENT_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/AdminCampaignManagementModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/InitialProductDisplayModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[FOLLOW_CREATOR_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/FollowCreatorModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[POINTS_CASH_OUT_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/PointsCashOutModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[NOTIFICATIONS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/NotificationsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[INITIAL_KEY_SELECTION_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/KeySelectionModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[BRAND_PAYMENT_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/BrandPaymentModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[DELETE_COUPON_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DeleteCouponModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[DROP_ADD_MORE_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DropAddMoreModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[VIDEO_PLAYER_MODAL_MODULE]: dynamic(() => import('root/src/client/web/modal/VideoPlayerModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[NO_CAMPAIGN_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/NoCampaignModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[CROP_IMAGE_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/CropImageModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[SUCCESS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/SuccessModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[GET_STARTED_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/GetStartedModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[SIGN_UP_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/auth/SignUpModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[SIGN_IN_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/auth/SignInModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[REVIEW_DELIVERY_OPTIONS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/ReviewDeliveryOptionsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[DROP_IS_OVER_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DropIsOverModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[NO_PUBLISHER_SETTINGS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/NoPublisherSettingsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[DELETE_ACCOUNT_MANAGER_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DeleteAccountManagerModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[TIKTOK_SET_EMAIL_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/TiktokSetEmailModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[HOW_TO_EARN_POINTS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/HowToEarnPointsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[WHITELIST_FORM_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/FormModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[MULTIGAME_DROP_REPORT_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/MultiGameDropReport'), { loading: () => <DynamicImportPlaceholder /> }),
	[EDIT_BRAND_KEYS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/EditBrandKeysModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[EDIT_BRAND_CODES_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/EditBrandCodesModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/PreviewBrandRewards'), { loading: () => <DynamicImportPlaceholder /> }),
	[DROP_JOINED_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DropJoined'), { loading: () => <DynamicImportPlaceholder /> }),
	[DARE_SUBMISSION_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/DareSubmissionModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[PUBLISHER_SETTINGS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/PublisherSettingsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[GET_VERIFIED_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/GetVerifiedModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.CREATE_GIVEAWAY_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/CreateGiveawayModal/CreateGiveawayModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.REDEEM_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/RedeemModal/RedeemModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.REDEEMED_REWARDS_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/RedeemedRewardsModal/RedeemedRewardsModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.REDEEM_CONFIRMATION_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/RedeemModalConfirmation/RedeemConfirmationModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.VERIFY_STEAM_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/VerifySteamModal/VerifySteamModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.ENTRY_FAILURE_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/EntryFailureModal/EntryFailureModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[SPONSORSHIP_DETAILS_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/SponsorshipDetailsModal').then(module => module.SponsorshipDetailsModal), { loading: () => <DynamicImportPlaceholder /> }),
	[authModuleIds.SIGN_IN_WITH_PROVIDER_MODAL_MODULE]: dynamic(() => import('root/src/client/web/auth/features/SignInWithProviderModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[authModuleIds.TRANSFORM_TO_CREATOR]: dynamic(() => import('root/src/client/web/auth/features/TransformToCreatorModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[giveawayModuleIds.GIVEAWAY_TERMS_CONDITION_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/giveaway/features/GiveawayTermsConditionModal'), { loading: () => <DynamicImportPlaceholder /> }),
	[PUBLISHER_BAN_LIST_FORM_MODAL_MODULE_ID]: dynamic(() => import('root/src/client/web/modal/FormModal'), { loading: () => <DynamicImportPlaceholder /> }),
}

export const ModalModuleUnconnected = memo(({
	classes, modalTitle, modalText, backBattonAction,
	modalModuleId, displayModal, modalProps, backButtonAction,
	routeId, closeButtonAction, onModalMount, ...props
}) => {
	const [downCoordinates, setDownCoordinates] = useState()
	const [formInput, setFormInput] = useState({})
	const [isCloseable, setIsCloseable] = useState(modalProps?.isCloseable ?? true)

	useEffect(() => {
		onModalMount(modalModuleId)
	}, [modalModuleId])

	useEffect(() => {
		setIsCloseable(modalProps?.isCloseable ?? true)
	}, [modalProps])

	const modalCloseHandler = useCallback(async () => {
		if (!isCloseable) {
			return
		}

		if (modalProps?.onClose) {
			await modalProps.onClose()
		}

		if (closeButtonAction) {
			await closeButtonAction()
		}

		const url = new URL(window.location.href)

		if (url.searchParams.has('modal')) {
			url.searchParams.delete('modal')
			window.history.replaceState({}, '', url.toString())
		}

		displayModal(undefined)
	}, [modalProps?.onClose, displayModal, isCloseable])

	const ModalComponent = useMemo(() => (
		modalModuleIds[modalModuleId]
	), [modalModuleIds, modalModuleId])

	const modalPropsMod = useMemo(() => ({
		displayModal,
		routeId,
		item: modalProps,
		modalModuleId,
		formInput,
		setFormInput,
		setIsCloseable,
		...props,
	}), [displayModal, routeId, modalProps, modalModuleId, props, formInput, setIsCloseable])

	const modalContextValue = useMemo(() => ({
		displayModal,
		onClose: modalCloseHandler,
	}), [displayModal])

	if (!ModalComponent) {
		return null
	}

	return (
		<ModalContextLegacyProvider value={modalContextValue}>
			<div
				className={classes.backdrop}
				onClick={(e) => {
					const { x, y } = e
					if (x === downCoordinates.x && y === downCoordinates.y) {
						modalCloseHandler()
					}
					setDownCoordinates()
				}}
				onMouseDown={(e) => {
					const { x, y } = e
					setDownCoordinates({ x, y })
				}}
			>
				<div
					onClick={e => e.stopPropagation()}
					className={classes.modal}
				>
					<div className={classes.contentContainer}>
						<div className={classes.container}>
							<div className={classes.content}>
								<div className={classes.modalActionButtons}>
									{isCloseable && (
										<button
											type="button"
											onClick={modalCloseHandler}
											className={classes.modalNavButton}
										>
											<FontAwesomeIcon icon={faTimesCircle} size="2x" color="#000000" />
										</button>
									)}
									{backButtonAction ? (
										<button
											type="button"
											onClick={() => backButtonAction(displayModal)}
											className={classes.modalNavButton}
										>
											<img src={backArrow.src} className={classes.backButtonIcon} alt="back" />
										</button>
									) : null}
								</div>
								{modalTitle && <div className={classes.title}>{modalTitle}</div>}
								{modalText && (
									<div className={classes.text}>
										{fillTemplate(modalText, modalProps)}
									</div>
								)}
								<ModalComponent props={modalPropsMod} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ModalContextLegacyProvider>
	)
})

export default withModuleContext(modalModuleConnector(ModalModuleUnconnected, styles, 'MuiModalModule'))
